const FacultySettings = () => {

  return (
    <div className=" h-full w-full bg-red-200">

    </div>
  );
};

export default FacultySettings;